// How long each product takes (Frank 2026-10-07), in one place: the designer's estimate and Sent view, the checkout
// summary, the receipt and the request email all say these, and the garments block says the window. No imports: the
// pages bundle it.

export type TurnaroundProduct = "apparel" | "transfers" | "own";

export const TURNAROUND: Record<TurnaroundProduct, string> = {
  apparel: "Ready in about 2 to 3 weeks.",
  transfers: "Ready in about 1 week.",
  own: "Ready in about 1 to 2 weeks after your garments arrive.",
};

// How soon the buyer's own garments should reach us after they order.
export const GARMENTS_WINDOW = "Please get your garments to us within 3 weeks of ordering.";
